import { useTheme } from "@mui/material";
import { semantic, surfaceTokens } from "../config/theme";

/**
 * Mode-aware status colors. The static `semantic` object holds the LIGHT-mode
 * anchors; on dark surfaces those (e.g. good `#0b7a34`, warn `#b45309`) are too
 * dark to read, so the brightened DARK variants are used instead. `buildTheme`
 * already maps these onto MUI's success/error/warning — this hook is the direct
 * source for components that color text/bars/chart series by sign.
 *
 * good = positive delta · bad = NEGATIVE numbers only · warn = caution.
 */
export interface StatusColors {
  good: string;
  bad: string;
  warn: string;
  neutral: string;
}

export function useStatusColors(): StatusColors {
  const { palette } = useTheme();
  const c = surfaceTokens(palette.mode === "dark");
  return { good: c.good, bad: c.bad, warn: c.warn, neutral: semantic.neutral };
}

/** Non-hook variant for code paths that already know the mode (e.g. chart fills). */
export function statusColors(isDark: boolean): StatusColors {
  const c = surfaceTokens(isDark);
  return { good: c.good, bad: c.bad, warn: c.warn, neutral: semantic.neutral };
}
